import React, { FC } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

import { IAlertRibbon } from "./model";

import "./style.scss";

export const Banner: FC<IAlertRibbon> = (props) => {
    const { message, showAlert, canDismiss = false, onDismiss, inApp = true, Icon, header } = props
    if (!showAlert) return null

    return (
        <div className={`alr ${inApp ? "" : "fw"}`}>
            <div className="container">
                <div className="message">
                    <div className="update-group">
                        <div className="icon">{Icon && <Icon />}</div>
                        <p className="header">{header}</p>
                    </div>
                    {message}
                </div>
                {canDismiss && onDismiss && (
                    <FontAwesomeIcon
                        icon={faTimes}
                        className="close-icon"
                        onClick={() => onDismiss()}
                        aria-hidden="true"
                    />
                )}
            </div>
        </div>
    )
}
